<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAlert_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M10.046 4.081c.87-1.508 3.049-1.508 3.92 0l7.84 13.578c.87 1.509-.219 3.395-1.96 3.395H4.166c-1.741 0-2.83-1.886-1.96-3.395zm1.953 12.282c-.588 0-1.065.48-1.065 1.07s.477 1.07 1.065 1.07h.01c.588 0 1.065-.479 1.065-1.07 0-.59-.477-1.07-1.065-1.07zm.01-8.558c-.587 0-1.064.48-1.064 1.07v4.28c0 .59.477 1.069 1.064 1.069s1.065-.479 1.065-1.07V8.876c0-.59-.477-1.07-1.065-1.07"
    />
</svg>
